// إعدادات عامة للموقع - Rush Store

export const SITE_CONFIG = {
  storeName: "Rush Store",
  storeNameAr: "راش ستور",
  logoUrl: "/rush-logo.png",
  storeUrl: "https://salla.sa/rushcp.com",
  whatsappNumber: "966509648113", // رقم واتساب متجر Rush Store الرسمي
  disclaimerText:
    "الأسعار والحسابات المعروضة مبنية على الجداول الرسمية المرفوعة من متجر Rush Store. يرجى التأكد من السعر النهائي قبل الشراء.",
  // تاريخ آخر تحديث للأسعار
  pricesLastUpdated: "2025-07-11",
};
